import { defineMessages } from 'react-intl';

export const miniDVMessages = defineMessages({
  title: { id: 'miniDV.title', defaultMessage: 'Artikeldetails' },
  artikelButton: { id: 'miniDV.artikelButton', defaultMessage: 'Zum Artikel' },
  confirmButton: { id: 'miniDV.confirmButton', defaultMessage: 'Änderung übernehmen' },
});
